import { generateURL } from 'utils/helpers';
import { apiSlice } from '.';

apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    ticketByBarcode: builder.query({
      query: ({ barcode, recaptchaToken }) =>
        generateURL(`/issued_tickets/usage/${barcode}`, {
          'g-recaptcha-response': recaptchaToken,
        }),
      providesTags: ['issued_tickets'],
      keepUnusedDataFor: 3600,
    }),
    printTickets: builder.mutation({
      query: ({ bookingId }) => ({
        url: generateURL(`/issued_tickets/print`),
        method: 'POST',
        body: JSON.stringify({ bookingId }),
      }),
    }),
  }),
});

export const { useLazyTicketByBarcodeQuery, usePrintTicketsMutation } =
  apiSlice;
